<template>
  <AbstractFilters :filters="filters"
                   :on-click="filter"
                   :selected-filter="postFilter"
  />
</template>
<script>
import AbstractFilters from './AbstractFilters'

export default {
  name: 'PostFilters',
  components: { AbstractFilters },
  async created() {
    await this.$store.dispatch('setPostFilter', 'myCommunities')
  },
  methods: {
    filter(name) {
      this.$store.dispatch('setPostFilter', name)
    }
  },
  computed: {
    postFilter() {
      return this.$store.getters.postsFilter
    },
    filters() {
      return [
        { name: this.$t('filter.postFilters.fromMyCommunities'), value: 'myCommunities' },
        { name: this.$t('filter.postFilters.myPublishedPosts'), value: 'myPublished' },
        { name: this.$t('filter.postFilters.myBookmarkedPosts'), value: 'myBookmarks' },
        { name: this.$t('filter.postFilters.all'), value: 'all' }
      ]
    }
  }
}
</script>
